import { render, staticRenderFns } from "./tjgly.vue?vue&type=template&id=07813f3a&scoped=true"
import script from "./tjgly.vue?vue&type=script&lang=js"
export * from "./tjgly.vue?vue&type=script&lang=js"
import style0 from "./tjgly.vue?vue&type=style&index=0&id=07813f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07813f3a",
  null
  
)

export default component.exports